var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loc-product-description"},[_c('p',{staticClass:"is-size-16px has-text-weight-semibold mb10"},[_vm._v("Description")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})])}
var staticRenderFns = []

export { render, staticRenderFns }